/**
 * Created with IntelliJ IDEA.
 * User: tendlich
 */
//ArticleContainerLayout


define(function (require) {
    "use strict";
    var LE = require("app");
    var template = require("connection-templates/ticketExtendedContainerLayout.tmpl");
    var NoData = require("ui.components/no-data/NoData");
    var Paging = require("ui/paging/Paging");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Loader = require("ui/loader/Loader");
    var BaseCollection = require("collections/BaseCollection");
    var Notifier = require("ui/notifier/Notifier");

    var TicketExtendedContainerLayout = {};

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketExtendedContainerLayout = Marionette.Layout.extend({
            className: 'connectionPanel-ticketContainer',
            template: template,
            regions: {
                noDataRegion: ".no-data",
                pageBodyRegion: ".expanded-ticket-body-container"
            },

            ui: {
                closeButton: ".close-ticket",
                pageBody: ".expanded-ticket-body-container"
            },

            triggers: {
                "click @ui.closeButton": "TicketExtendedContainerController::container:close"
            },

            initialize: function (options) {
                this.isOpen = false;
            },

            onRender: function () {
                this.hide();
                $(this.$el).on('click','*',_.bind(this._onClickInsideContainer,this));
            },

            toggleNoData: function (toggle) {
                if (this.noData) {
                    this.noData.el.toggleClass("hide", toggle);
                }
                else {
                    this._renderNoData();
                }
            },

            setOnTop: function (value) {
                this.$el.toggleClass("decrease-z-index",!value);
            },

            _renderNoData: function () {
                this.noData = new NoData({
                    el: this.$el.find(".no-data"),
                    permutation: NoData.PERMUTATION.REFRESH_LINK_MEDIUM,
                    callback: _.bind(this._onNoDataClick, this),
                    errorMessage: LE.translator.translate("LEConnection.connectionPanel.error404")
                });
                this.noData.render();
            },

            _onNoDataClick: function () {
                LEConnection.vent.trigger("nodata:click:refresh");
                LE.navigator.reload();
            },

            _onClickInsideContainer: function(event){
                //check if click was from suggestions view(snippet) if not, then set top element
                if(event.target.className.indexOf("snippet")===-1){
                    this.trigger("TicketExtendedContainerController::container:clickInside");
                }
            },

            close: function(){
                this.isOpen = false;
                _.defer(_.bind(function(){
                    var self = this;
                    this.$el.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function () {
                        if(!self.isOpen){
                            self.hide();
                        }
                    });

                    this.$el.removeClass("extended-ticket-view");
                    this.$el.removeClass("detailed-ticket-view");

                },this));
            },
            hide: function(){
                this.$el.addClass("hide");
            },
            show: function(){
                this.$el.removeClass("hide");
                this.isOpen = true;
            },
            fadeInFadeOut: function(){
                //todo, make fadeout fadein of content div, when switching ticketviews/modelss
            },
            changeToDetailedView: function(){
                this.$el.addClass("detailed-ticket-view");
                this.$el.removeClass("extended-ticket-view");
            },
            changeToExtendedView: function(){
                this.$el.removeClass("detailed-ticket-view");
                this.$el.addClass("extended-ticket-view");
            }
        });
    });
    return TicketExtendedContainerLayout;
});
